/* eslint-disable */

import React, { Component } from 'react';
import { Link } from 'react-router';
import Modal from 'react-modal';
import { branch } from 'baobab-react/higher-order';
import renderHTML from 'react-render-html';
import Helmet from 'react-helmet';

import OverviewMedia from './OverviewMedia';
import HatchDetail from './HatchDetail';
import Features from './Features';
import ProductDetailSupport from './ProductDetailSupport';
import ProductSpecifications from './ProductSpecifications';
import Protections from './Protections';
import PlacementImage from './PlacementImage';
import config from '../../config';
import Accessories from './accessories/AccessoriesContainer';
import BoughtTogetherContainer from "./boughttogether/BoughtTogetherContainer";
import OverviewDescription from "./OverviewDescription";
import TrackedLink from "../common/TrackedLink";
import {buildPdpProductArrayForPush, pushNewEcommerceEvent} from "../../utils/datalayer";

// const customStyles = {
// 	content: {F
// 		top: '50%',
// 		left: '50%',
// 		right: 'auto',
// 		bottom: 'auto',
// 		border: 'none',
// 		borderRadius: 'none',
// 		boxShadow: '2px 2px 9px rgba(0,0,0,0.15)',
// 		zIndex: '6'
// 	}
// };

class Overview extends Component {
	constructor(props) {
		super(props);
		this.state = {
			// modalOpen: false
		};
		this.trackBuyNow = this.trackBuyNow.bind(this);
		this.trackWhereToBuy = this.trackWhereToBuy.bind(this);
	}

	componentDidMount() {
		this.observePsButton();
	}

	componentWillUnmount() {
		const btn = document.querySelector(".ps-widget");
		if (btn) {
			btn.removeEventListener("click", this.trackWhereToBuy);
		}
	}

	observePsButton() {
		// Try to find it right away
		const btn = document.querySelector(".ps-widget");
		if (btn) {
			btn.addEventListener("click", this.trackWhereToBuy);
			return;
		}

		// If the external script injects it later, use a MutationObserver
		const observer = new MutationObserver(() => {
			const btn = document.querySelector(".ps-widget");
			if (btn) {
				btn.addEventListener("click", this.trackWhereToBuy);
				observer.disconnect(); // stop watching once found
			}
		});

		observer.observe(document.body, { childList: true, subtree: true });
	}

	trackBuyNow = (e) => {
		const skuModel = e.target.attributes.getNamedItem('data-bn-sku').value;
		window.BV.pixel.trackConversion({
			"type": "BuyNow",
			"label": "value",
			"value": skuModel
		});

		const items = buildPdpProductArrayForPush(this.props.product);
		const {ecommerceSalesPrice, ecommerceRegularPrice} = this.props.product;
		const price = ecommerceSalesPrice || ecommerceRegularPrice || undefined;
		pushNewEcommerceEvent('buy_now', items, null, 'USD', price.toString());
	}

	trackWhereToBuy = () => {
		const skuModel = this.props.product.overView.modelNumber;
		window.BV.pixel.trackConversion({
			"type": "WhereToBuy",
			"label": "value",
			"value": skuModel
		});

		const items = buildPdpProductArrayForPush(this.props.product);
		const {ecommerceSalesPrice, ecommerceRegularPrice} = this.props.product;
		const price = ecommerceSalesPrice || ecommerceRegularPrice || undefined;
		pushNewEcommerceEvent('where_to_buy', items, null, 'USD', price.toString());
	}

	// openModal() {
	// 	const description = this.props.product.overView.description;
	// 	const modelNumber = this.props.product.overView.modelNumber;
	// 	this.setState({ modalOpen: true });

	// 	global.dataLayer.push({
	// 		event: 'Where to Buy',
	// 		eventCategory: 'Where to Buy',
	// 		eventAction: 'click',
	// 		eventLabel: `${description} - Model ${modelNumber}`
	// 	});
	// }

	// closeModal() {
	// 	this.setState({ modalOpen: false });
	// }

	render() {
		const productOverview = this.props.product.overView;
		const productUrl = `http://www.sentrysafe.com/product/${productOverview.modelNumber}`;
		const productBVReviews = this.props.product.bvReviews;
		const productBVAggregateRatings = this.props.product.bvAggregateRatings;

		// console.log("PRODUCT");
		// console.dir(this.props.product);

		let productStatusMessage;
		if (this.props.product.productStatusMessage) {

			let statusClassName = "product__status_message";
			if (this.props.product.productStatusMessage.toLowerCase().startsWith("our new")) {
				statusClassName = "product__status_message text-red";
			}
			productStatusMessage = (
				<div className={statusClassName}>
					<strong>{this.props.product.productStatusMessage}</strong>
				</div>
			)
		}

		let retiringLink;
		let buyNow;
		if (this.props.product.retiringSoonLink && !this.props.product.buyNow) {
			retiringLink = (
				<div className="pt-3">
					<TrackedLink to={this.props.product.retiringSoonLink}>{this.props.product.retiringSoonMessage}</TrackedLink>
				</div>
			)
		}

		let retailOptions;
		let regularPrice;
		let onSalePrice;
		let onSaleFlag;
		let couponCodeSection;
		let mediaShow;
		let capacity;
		let placementImage;
		let protections;
		let accessories;

		let originalPrice = parseFloat(this.props.product.ecommerceSalesPrice);
		let price = parseFloat(this.props.product.ecommerceRegularPrice);

		let isProductOnSale = false;
		const formatterUSD = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
		if (originalPrice && (originalPrice > price)) {
			isProductOnSale = true;
			// onSalePrice = '$' + price;
			// regularPrice = '$' + originalPrice;
			onSalePrice = formatterUSD.format(price);
			regularPrice = formatterUSD.format(originalPrice);
		} else {
			onSalePrice = null;
			// regularPrice = '$' + price;
			regularPrice = formatterUSD.format(price);
		}

		/*
		// to enable coupon code section, and the models that uses it, specify theme here:
		const couponCode = "FIRESAFE10";
		// const modelsThatCanUseCouponCode = ['SFW123CS','SFW123DTB','SFW205DPB','SFW205GRC','SFW205TXC','SFW123GTC','SFW205EVB','SFW123CTB'];
	
		// otherwise just blank them
		//const couponCode="";
		const modelsThatCanUseCouponCode = [];
	
		const conponPromoText = "Get 10% off. Enter code at SentrySafe checkout.";
	
		if (modelsThatCanUseCouponCode.includes(productOverview.modelNumber)) {
		*/

		const couponPromoText = this.props.product.couponPercentage;
		const couponCode = this.props.product.couponCode;
		var couponCodeHeader = this.props.product.discountHeader;
		if (couponCodeHeader == null) {
			couponCodeHeader = "Buy Now from SentrySafe <br /> &#43; Free Shipping<sup>&#42;</sup>";
		}

		if (couponCode != null) {
			couponCodeSection = (
				<div className="row mx-0 my-2 coupon-flag">
					<div className="coupon-body"><em>{couponPromoText}</em></div>
					<div className="coupon-code">{couponCode}</div>
				</div>
			);
		}

		if (productOverview.media !== undefined && productOverview.media.length > 0) {
			// console.log("LENGTH: " + productOverview.media.length);
			mediaShow = <OverviewMedia />;
		}

		if (this.props.standard) {
			capacity = `${productOverview.stdCapacity} cubic ft`;
		} else {
			capacity = `${productOverview.mtcCapacity} liters`;
		}
		// console.log("ECOM SALES PRICE: " + this.props.product.ecommerceSalesPrice);
		// if (!this.props.product.ecommerceSalesPrice) {
		// 	regularPrice = (
		// 		<div className="regular-price left pl-2">${this.props.product.ecommerceRegularPrice}</div>
		// 	)
		// }

		if (onSalePrice) {
			// onSaleFlag = (
			// 	<div className="on-sale-flag pt-1">
			// 		<img
			// 			src={require('../../resources/img/icons/on-sale-flag.png')}
			// 			srcSet={`${require('../../resources/img/icons/on-sale-flag.png')} 2x`}
			// 			alt="On Sale"
			// 		/>
			// 	</div>
			// )
			onSalePrice = (
				<div className="left on-sale-price p-2">
					<div className="regular-price">{regularPrice}</div>
					<div className="sale-price">{onSalePrice}</div>
				</div>
			)
		} else {
			onSalePrice = (
				<div className="regular-price left pl-2">${this.props.product.ecommerceRegularPrice}</div>
			)
		}

		if (this.props.product.directToCustomer && this.props.product.statusId == 1) {
			buyNow = (
				<div className="buy-now pb-2 mb-3">
					{onSaleFlag}
					<div className="button-price my-3">
						<a
							data-bn-sku={this.props.product.overView.modelNumber}
							className="btn btn-primary left"
							href={this.props.product.ecommerceProductURL}
							onClick={e => this.trackBuyNow(e)}
						>Buy Now</a>
						{/* {regularPrice} */}
						{onSalePrice}
					</div>
					{couponCodeSection}
					<div className="font-weight-bold pt-2 pb-0">
						{renderHTML(couponCodeHeader)} {/*Buy Now from SentrySafe <br /> &#43; Free Shipping<sup>&#42;</sup>*/}
					</div>
					<div className="footnote pt-0 pb-md-3">Orders from SentrySafe can only be shipped to the contiguous United States.
					</div>
				</div>
			)
		}

		if (productOverview.buyNow && this.props.product.statusId == 1) {
			/*if (productOverview.retailOptions) {*/
			// let psAttrs = { 'ps-sku': this.props.product.overView.modelNumber }
			retailOptions = (
				<div
					className={`row m-0 mb-3 pt-2 buy-now-container ${this.props.product.directToCustomer && this.props.product.statusId == 1 ? 'not-primary-action' : 'primary-action mt-3'}`}>
					{!this.props.product.directToCustomer && <div className="price-range pb-1">Price Range&#58; {this.props.product.priceBucket}</div>}
					<div className="ps-container">
						<div id="ps-wrapper" className='ps-ss-wrapper'>
							<div className="ps-widget" data-ps-sku={this.props.product.overView.modelNumber}></div>
						</div>
					</div>
				</div>
			);
		}

		if (this.props.product.placementImage !== undefined) {
			placementImage = (
				<PlacementImage placementImage={this.props.product.placementImage} />
			);
		}

		if (this.props.product.hasProtections) {
			protections = (
				<Protections product={this.props.product} />
			);
		}

		if (this.props.product.productAccessories !== undefined && this.props.product.productAccessories.length > 0) {

			// Fire Bag
			if (this.props.product.overView.name == config.SKU_FIRE_BAG) {
				accessories = (
					<BoughtTogetherContainer boughtTogether={this.props.product.productAccessories} />
				);

			}
			else {
				accessories = (
					<Accessories accessories={this.props.product.productAccessories} />
				);
			}
		}
		let masterLockSecurityBuiltInProtection;

		if (productOverview.masterlockSecurityBuiltInProtection) {
			masterLockSecurityBuiltInProtection = (
				<li className="built-in-protection mb-2">
					<p>with Master Lock Security Built In</p>
				</li>
			);
		}

		return (
			<section itemScope itemType="http://schema.org/Product">
				<Helmet defer={false}>
					<script async src={config.bazaarVoiceScriptUrl} />
				</Helmet>
				<link itemProp="url" href={productUrl} />
				<div className="top-section">
					<div className="row">
						<div className="col sm-4 main-features">
							<ul>
								{this.props.product.saleFlag && <li>
									<div className="flags flags-inline mb-2">
										<span className="flag flag-yellow">
											<span className="flag-text">Sale</span>
										</span>
									</div>
								</li>
								}
								<li className="category-name">
									<h1 itemProp="name">
										<span className="assistive-text">SentrySafe</span>
										<span> {productOverview.description}</span>
										<span className="assistive-text">: Model {productOverview.modelNumber}</span>
									</h1>
								</li>
								{masterLockSecurityBuiltInProtection}
								<li className="product-rating-summary mb-2">
									<div
										data-bv-show="rating_summary"
										data-bv-product-id={productOverview.modelNumber}
									>
										{renderHTML(productBVAggregateRatings)}
									</div>
								</li>
								<li className="size-model my-1">
									<span className="size">{productOverview.size}</span>
									Model <span itemProp="mpn">{productOverview.modelNumber}</span>
								</li>
								<li>
									Interior Capacity {capacity}
								</li>
								<li className="buy-now">
									{buyNow}
								</li>
								<li className="clear">
									{retailOptions}
								</li>
								{productStatusMessage}
								{retiringLink}
							</ul>
						</div>
						{mediaShow}
					</div>
				</div>

				{protections}

				<OverviewDescription description={productOverview.overView} />

				<Features />

				<ProductSpecifications standard={this.props.standard} />

				{placementImage}

				{accessories}

				<ProductDetailSupport />

				<div data-bv-show="reviews" data-bv-product-id={productOverview.modelNumber}>
					{renderHTML(productBVReviews)}
				</div>

				<div data-bv-show="questions" data-bv-product-id={productOverview.modelNumber} />
			</section>
		);
	}
}

export default branch({
	product: ['product']
}, Overview);


// WEBPACK FOOTER //
// ./src/pages/product/Overview.js